"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonText = exports.SkeletonBox = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _helpers = require("../../helpers");

var _splitProps = require("../../utils/splitProps");

var _Box = require("../Box");

var _Text = require("../Text");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PULSE = (0, _styledComponents.keyframes)(["0%{background-color:", ";}50%{background-color:", ";}100%{background-color:", ";}"], (0, _helpers.color)("black10"), (0, _helpers.color)("black5"), (0, _helpers.color)("black10"));
var Skeleton = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Skeleton",
  componentId: "sc-1vwqe5c-0"
})(["", ""], function (_ref) {
  var done = _ref.done;
  return done ? (0, _styledComponents.css)(["background-color:", ";"], (0, _helpers.color)("black10")) : (0, _styledComponents.css)(["animation:", " 2s ease-in-out infinite;"], PULSE);
});
/** SkeletonProps */

/** Skeleton */
var SkeletonBox = function SkeletonBox(_ref2) {
  var done = _ref2.done,
      rest = _objectWithoutProperties(_ref2, ["done"]);

  return _react.default.createElement(Skeleton, _extends({
    "aria-busy": !done,
    done: done,
    borderRadius: 2
  }, rest));
};

exports.SkeletonBox = SkeletonBox;
SkeletonBox.displayName = "SkeletonBox";
var splitBorderProps = (0, _splitProps.splitProps)(_styledSystem.border);
/** SkeletonTextProps */

var SkeletonTextOverlay = (0, _styledComponents.default)(SkeletonBox).withConfig({
  displayName: "Skeleton__SkeletonTextOverlay",
  componentId: "sc-1vwqe5c-1"
})(["position:absolute;top:50%;left:0;width:100%;height:85%;transform:translateY(-50%);"]);
/** SkeletonText */

var SkeletonText = function SkeletonText(_ref3) {
  var children = _ref3.children,
      done = _ref3.done,
      rest = _objectWithoutProperties(_ref3, ["children", "done"]);

  var _splitBorderProps = splitBorderProps(rest),
      _splitBorderProps2 = _slicedToArray(_splitBorderProps, 2),
      borderProps = _splitBorderProps2[0],
      notBorderProps = _splitBorderProps2[1];

  return _react.default.createElement(_Text.Text, _extends({
    "aria-busy": !done
  }, notBorderProps), _react.default.createElement(_Box.Box, {
    as: "span",
    display: "inline-flex",
    position: "relative",
    "aria-hidden": "true"
  }, children, _react.default.createElement(SkeletonTextOverlay, borderProps)));
};

exports.SkeletonText = SkeletonText;
SkeletonText.displayName = "SkeletonText";
//# sourceMappingURL=Skeleton.js.map